/* @flow */

import { rem } from 'polished';
import { baseFontSize } from '@braindate/ui/lib/token/typography';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: ({ theme }: ThemeFunction) => theme.textColor,
  },
  title: {
    fontSize: rem(15, baseFontSize),
    fontWeight: 500,
    marginBottom: 0,
    textOverflow: 'ellipsis',
    textAlign: 'left',
  },
  titleName: {
    marginRight: 12,
  },
  name: {
    fontSize: rem(15, baseFontSize),
    fontWeight: 700,
  },
  link: {
    textAlign: 'left',
  },
};
